module.exports = __webpack_public_path__ + "static/img/home_plataforma.892965a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_plataforma.png
// module id = 85
// module chunks = 0